export default __webpack_public_path__ + "static/media/selected_point.e3d56c93.png";